import { useCallback, useEffect, useMemo, useState } from 'react';
import { IntlShape } from 'react-intl';

import { api } from '../../common-utils-services/axiosUtil';
import { configs } from '../../../constants/configs/configs';

import { IAttachment, IIssuer, IIssuerListResponse } from '../types/adminSerffStatus.interface';

export const useIssuerList = (intl: IntlShape, placeHolder?: string) => {
    const [issuerList, setIssuerList] = useState<IIssuer[]>([]);

    const fetchIssuerList = useCallback(async () => {
        const url = configs.endpoints.ADMIN_SERFF_ISSUER_LIST;
        try {
            const { data: response } = await api.get<IIssuerListResponse>(url);
            const data = response?.data?.issuers;

            if (data?.length) {
                setIssuerList(data);
            }
        } catch (error) {
            throw new Error(error);
        }
    }, []);

    const issuerDropdownOptions = useMemo(() => {
        return [
            {
                value: '',
                text: intl.formatMessage({ id: placeHolder ?? 'form.option.select' }),
            },
            ...issuerList.map(({ hiosIssuerId = '', name = '' }) => ({
                value: hiosIssuerId,
                text: `[${hiosIssuerId}] ${name}`,
            })),
        ];
    }, [issuerList]);

    useEffect(() => {
        fetchIssuerList();
    }, []);

    return {
        issuerDropdownOptions,
    };
};

export const useAttachmentList = () => {
    const [attachmentList, setAttachmentList] = useState<IAttachment[]>([]);

    const fetchAttachments = async (selectedRecordID: string|number) => {
        const url = configs.endpoints.ADMIN_SERFF_PLAN_ATTACHMENTS_LIST.processReplacements({
            selectedRecordID:selectedRecordID,
        });
        try {
            const { data } = await api.get(url);

            setAttachmentList(data ?? []);
            return data ?? [];
        } catch (error) {
            console.error('Failed to fetch attachments', error);
            setAttachmentList([]);
        }
    };

    return {
        attachmentList,
        fetchAttachments,
    };

};

